import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';

import useOpenModal from '../../../../hooks/useOpenModal';
import { CONSUMER_FEEDBACK_MODAL } from '../../../../components/global/ConsumerFeedbackModal';
import { SUPPORT_MODAL } from '../../../../constants/modals';
import { MeQuery } from '../../../../graphql/queries/account';
import { isShutterbug } from '../../../../util/account';

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node,
};

const AssistanceActionButton = ({ className, icon }) => {
  const openModal = useOpenModal();
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });
  const classes = classNames({
    [className]: !!className,
  });

  if (!authenticated || !user) {
    return null;
  }

  return (
    <Fragment>
      <button
        id="user-account-menu-help-desk-btn"
        className={classes}
        onClick={() => {
          if (!isShutterbug(user)) {
            openModal(SUPPORT_MODAL);
          } else {
            openModal(CONSUMER_FEEDBACK_MODAL);
          }
        }}
      >
        {icon}
        Contact Support
      </button>
    </Fragment>
  );
};

AssistanceActionButton.propTypes = propTypes;

export default AssistanceActionButton;
